import {AbstractRouter} from "../Router";
import {DailyReport} from "../DailyReport";
import {Properties} from "../../common/properties";
import {RealtimeReport} from "../RealtimeReport";

class CreditRouter extends AbstractRouter {

    getConfigDicts() {
        const txnConfigDicts = [
            {
                metric: 'txn',
                reportLabel: 'Txn',
                frequency: Properties.frequencyBit.realtime,
                reportClass: RealtimeReport,
            },
            {
                metric: 'txn',
                reportLabel: 'Txn',
                frequency: Properties.frequencyBit.daily,
                reportClass: DailyReport,
            },
            {
                metric: 'txn_spl',
                reportLabel: 'Txn (SPayLater - On Platform)',
                frequency: Properties.frequencyBit.realtime,
                reportClass: RealtimeReport,
            },
            {
                metric: 'txn_spl',
                reportLabel: 'Txn (SPayLater - On Platform)',
                frequency: Properties.frequencyBit.daily,
                reportClass: DailyReport,
            },
            {
                metric: 'txn_spl-offline',
                reportLabel: 'Txn (SPayLater - Off Platform)',
                frequency: Properties.frequencyBit.realtime,
                reportClass: RealtimeReport,
            },
            {
                metric: 'txn_spl-offline',
                reportLabel: 'Txn (SPayLater - Off Platform)',
                frequency: Properties.frequencyBit.daily,
                reportClass: DailyReport,
            },
            {
                metric: 'txn_bcl',
                reportLabel: 'Txn (Buyer Cash Loan)',
                frequency: Properties.frequencyBit.realtime,
                reportClass: RealtimeReport,
            },
            {
                metric: 'txn_bcl',
                reportLabel: 'Txn (Buyer Cash Loan)',
                frequency: Properties.frequencyBit.daily,
                reportClass: DailyReport,
            },
            {
                metric: 'txn_scl',
                reportLabel: 'Txn (Seller Cash Loan)',
                frequency: Properties.frequencyBit.realtime,
                reportClass: RealtimeReport,
            },
            {
                metric: 'txn_scl',
                reportLabel: 'Txn (Seller Cash Loan)',
                frequency: Properties.frequencyBit.daily,
                reportClass: DailyReport,
            },
            {
                metric: 'txn_fel',
                reportLabel: 'Txn (Fast Escrow)',
                frequency: Properties.frequencyBit.realtime,
                reportClass: RealtimeReport,
            },
            {
                metric: 'txn_fel',
                reportLabel: 'Txn (Fast Escrow)',
                frequency: Properties.frequencyBit.daily,
                reportClass: DailyReport,
            },
            {
                metric: 'txn_spl-xtra',
                reportLabel: 'Txn (SPL - Xtra)',
                frequency: Properties.frequencyBit.realtime,
                reportClass: RealtimeReport,
            },
            {
                metric: 'txn_spl-xtra',
                reportLabel: 'Txn (SPL - Xtra)',
                frequency: Properties.frequencyBit.daily,
                reportClass: DailyReport,
            },
            {
                metric: 'txn_tl',
                reportLabel: 'Txn (Term Loan)',
                frequency: Properties.frequencyBit.realtime,
                reportClass: RealtimeReport,
            },
            {
                metric: 'txn_tl',
                reportLabel: 'Txn (Term Loan)',
                frequency: Properties.frequencyBit.daily,
                reportClass: DailyReport,
            },
            {
                metric: 'txn_spl-total',
                reportLabel: 'Txn (SPayLater - Total)',
                frequency: Properties.frequencyBit.realtime,
                reportClass: RealtimeReport,
            },
            {
                metric: 'txn_spl-total',
                reportLabel: 'Txn (SPayLater - Total)',
                frequency: Properties.frequencyBit.daily,
                reportClass: DailyReport,
            }
        ]
        const tpvConfigDicts = [
            {
                metric: 'tpv',
                reportLabel: 'Tpv',
                frequency: Properties.frequencyBit.realtime,
                reportClass: RealtimeReport,
            },
            {
                metric: 'tpv',
                reportLabel: 'Tpv',
                frequency: Properties.frequencyBit.daily,
                reportClass: DailyReport,
            },
            {
                metric: 'tpv_spl',
                reportLabel: 'Tpv (SPayLater - On Platform)',
                frequency: Properties.frequencyBit.realtime,
                reportClass: RealtimeReport,
            },
            {
                metric: 'tpv_spl',
                reportLabel: 'Tpv (SPayLater - On Platform)',
                frequency: Properties.frequencyBit.daily,
                reportClass: DailyReport,
            },
            {
                metric: 'tpv_spl-offline',
                reportLabel: 'Tpv (SPayLater - Off Platform)',
                frequency: Properties.frequencyBit.realtime,
                reportClass: RealtimeReport,
            },
            {
                metric: 'tpv_spl-offline',
                reportLabel: 'Tpv (SPayLater - Off Platform)',
                frequency: Properties.frequencyBit.daily,
                reportClass: DailyReport,
            },
            {
                metric: 'tpv_bcl',
                reportLabel: 'Tpv (Buyer Cash Loan)',
                frequency: Properties.frequencyBit.realtime,
                reportClass: RealtimeReport,
            },
            {
                metric: 'tpv_bcl',
                reportLabel: 'Tpv (Buyer Cash Loan)',
                frequency: Properties.frequencyBit.daily,
                reportClass: DailyReport,
            },
            {
                metric: 'tpv_scl',
                reportLabel: 'Tpv (Seller Cash Loan)',
                frequency: Properties.frequencyBit.realtime,
                reportClass: RealtimeReport,
            },
            {
                metric: 'tpv_scl',
                reportLabel: 'Tpv (Seller Cash Loan)',
                frequency: Properties.frequencyBit.daily,
                reportClass: DailyReport,
            },
            {
                metric: 'tpv_fel',
                reportLabel: 'Tpv (Fast Escrow)',
                frequency: Properties.frequencyBit.realtime,
                reportClass: RealtimeReport,
            },
            {
                metric: 'tpv_fel',
                reportLabel: 'Tpv (Fast Escrow)',
                frequency: Properties.frequencyBit.daily,
                reportClass: DailyReport,
            },
            {
                metric: 'tpv_spl-xtra',
                reportLabel: 'Tpv (SPL - Xtra)',
                frequency: Properties.frequencyBit.realtime,
                reportClass: RealtimeReport,
            },
            {
                metric: 'tpv_spl-xtra',
                reportLabel: 'Tpv (SPL - Xtra)',
                frequency: Properties.frequencyBit.daily,
                reportClass: DailyReport,
            },
            {
                metric: 'tpv_tl',
                reportLabel: 'Tpv (Term Loan)',
                frequency: Properties.frequencyBit.realtime,
                reportClass: RealtimeReport,
            },
            {
                metric: 'tpv_tl',
                reportLabel: 'Tpv (Term Loan)',
                frequency: Properties.frequencyBit.daily,
                reportClass: DailyReport,
            },
            {
                metric: 'tpv_spl-total',
                reportLabel: 'Tpv (SPayLater - Total)',
                frequency: Properties.frequencyBit.realtime,
                reportClass: RealtimeReport,
            },
            {
                metric: 'tpv_spl-total',
                reportLabel: 'Tpv (SPayLater - Total)',
                frequency: Properties.frequencyBit.daily,
                reportClass: DailyReport,
            },
        ]
        const txnProportionConfigDicts = [
            {
                metric: 'txn_proportion',
                reportLabel: 'Gross Order %',
                frequency: Properties.frequencyBit.daily,
                reportClass: DailyReport,
            },
            {
                metric: 'txn_proportion_spl',
                reportLabel: 'Gross Order % (SPayLater - On Platform)',
                frequency: Properties.frequencyBit.daily,
                reportClass: DailyReport,
            },
            {
                metric: 'txn_proportion_spl-offline',
                reportLabel: 'Gross Order % (SPayLater - Off Platform)',
                frequency: Properties.frequencyBit.daily,
                reportClass: DailyReport,
            },
            {
                metric: 'txn_proportion_bcl',
                reportLabel: 'Gross Order % (Buyer Cash Loan)',
                frequency: Properties.frequencyBit.daily,
                reportClass: DailyReport,
            },
            {
                metric: 'txn_proportion_scl',
                reportLabel: 'Gross Order % (Seller Cash Loan)',
                frequency: Properties.frequencyBit.daily,
                reportClass: DailyReport,
            },
            {
                metric: 'txn_proportion_fel',
                reportLabel: 'Gross Order % (Fast Escrow)',
                frequency: Properties.frequencyBit.daily,
                reportClass: DailyReport,
            },
            {
                metric: 'txn_proportion_spl-xtra',
                reportLabel: 'Gross Order % (SPL - Xtra)',
                frequency: Properties.frequencyBit.daily,
                reportClass: DailyReport,
            },
            {
                metric: 'txn_proportion_tl',
                reportLabel: 'Gross Order % (Term Loan)',
                frequency: Properties.frequencyBit.daily,
                reportClass: DailyReport,
            },
        ]
        const gmvProportionConfigDicts = [
            {
                metric: 'gmv_proportion',
                reportLabel: 'Gmv %',
                frequency: Properties.frequencyBit.daily,
                reportClass: DailyReport,
            },
            {
                metric: 'gmv_proportion_spl',
                reportLabel: 'Gmv % (SPayLater - On Platform)',
                frequency: Properties.frequencyBit.daily,
                reportClass: DailyReport,
            },
            {
                metric: 'gmv_proportion_spl-offline',
                reportLabel: 'Gmv % (SPayLater - Off Platform)',
                frequency: Properties.frequencyBit.daily,
                reportClass: DailyReport,
            },
            {
                metric: 'gmv_proportion_bcl',
                reportLabel: 'Gmv % (Buyer Cash Loan)',
                frequency: Properties.frequencyBit.daily,
                reportClass: DailyReport,
            },
            {
                metric: 'gmv_proportion_scl',
                reportLabel: 'Gmv % (Seller Cash Loan)',
                frequency: Properties.frequencyBit.daily,
                reportClass: DailyReport,
            },
            {
                metric: 'gmv_proportion_fel',
                reportLabel: 'Gmv % (Fast Escrow)',
                frequency: Properties.frequencyBit.daily,
                reportClass: DailyReport,
            },
            {
                metric: 'gmv_proportion_spl-xtra',
                reportLabel: 'Gmv % (SPL - Xtra)',
                frequency: Properties.frequencyBit.daily,
                reportClass: DailyReport,
            },
            {
                metric: 'gmv_proportion_tl',
                reportLabel: 'Gmv % (Term Loan)',
                frequency: Properties.frequencyBit.daily,
                reportClass: DailyReport,
            },
        ]
        const loanOutstandingConfigDicts = [
            {
                metric: 'loan_outstanding',
                reportLabel: 'Loan O/S',
                frequency: Properties.frequencyBit.realtime,
                reportClass: RealtimeReport,
            },
            {
                metric: 'loan_outstanding_spl',
                reportLabel: 'Loan O/S (SPayLater - On Platform)',
                frequency: Properties.frequencyBit.realtime,
                reportClass: RealtimeReport,
            },
            {
                metric: 'loan_outstanding_spl-offline',
                reportLabel: 'Loan O/S (SPayLater - Off Platform)',
                frequency: Properties.frequencyBit.realtime,
                reportClass: RealtimeReport,
            },
            {
                metric: 'loan_outstanding_bcl',
                reportLabel: 'Loan O/S (Buyer Cash Loan)',
                frequency: Properties.frequencyBit.realtime,
                reportClass: RealtimeReport,
            },
            {
                metric: 'loan_outstanding_scl',
                reportLabel: 'Loan O/S (Seller Cash Loan)',
                frequency: Properties.frequencyBit.realtime,
                reportClass: RealtimeReport,
            },
            {
                metric: 'loan_outstanding_fel',
                reportLabel: 'Loan O/S (Fast Escrow)',
                frequency: Properties.frequencyBit.realtime,
                reportClass: RealtimeReport,
            },
            {
                metric: 'loan_outstanding_spl-xtra',
                reportLabel: 'Loan O/S (SPL - Xtra)',
                frequency: Properties.frequencyBit.realtime,
                reportClass: RealtimeReport,
            },
            {
                metric: 'loan_outstanding_tl',
                reportLabel: 'Loan O/S (Term Loan)',
                frequency: Properties.frequencyBit.realtime,
                reportClass: RealtimeReport,
            },
            {
                metric: 'loan_outstanding_spl-total',
                reportLabel: 'Loan O/S (SPayLater - Total)',
                frequency: Properties.frequencyBit.realtime,
                reportClass: RealtimeReport,
            },
            {
                metric: 'loan_outstanding',
                reportLabel: 'Loan O/S',
                frequency: Properties.frequencyBit.daily,
                reportClass: DailyReport,
            },
            {
                metric: 'loan_outstanding_spl',
                reportLabel: 'Loan O/S (SPayLater - On Platform)',
                frequency: Properties.frequencyBit.daily,
                reportClass: DailyReport,
            },
            {
                metric: 'loan_outstanding_spl-offline',
                reportLabel: 'Loan O/S (SPayLater - Off Platform)',
                frequency: Properties.frequencyBit.daily,
                reportClass: DailyReport,
            },
            {
                metric: 'loan_outstanding_bcl',
                reportLabel: 'Loan O/S (Buyer Cash Loan)',
                frequency: Properties.frequencyBit.daily,
                reportClass: DailyReport,
            },
            {
                metric: 'loan_outstanding_scl',
                reportLabel: 'Loan O/S (Seller Cash Loan)',
                frequency: Properties.frequencyBit.daily,
                reportClass: DailyReport,
            },
            {
                metric: 'loan_outstanding_fel',
                reportLabel: 'Loan O/S (Fast Escrow)',
                frequency: Properties.frequencyBit.daily,
                reportClass: DailyReport,
            },
            {
                metric: 'loan_outstanding_spl-xtra',
                reportLabel: 'Loan O/S (SPL - Xtra)',
                frequency: Properties.frequencyBit.daily,
                reportClass: DailyReport,
            },
            {
                metric: 'loan_outstanding_tl',
                reportLabel: 'Loan O/S (Term Loan)',
                frequency: Properties.frequencyBit.daily,
                reportClass: DailyReport,
            },
            {
                metric: 'loan_outstanding_spl-total',
                reportLabel: 'Loan O/S (SPayLater - Total)',
                frequency: Properties.frequencyBit.daily,
                reportClass: DailyReport,
            },
        ]
        const loanOutstandingDiffConfigDicts = [
            {
                metric: 'loan_outstanding_diff',
                reportLabel: 'Loan O/S Diff',
                frequency: Properties.frequencyBit.realtime,
                reportClass: RealtimeReport,
            },
            {
                metric: 'loan_outstanding_diff',
                reportLabel: 'Loan O/S Diff',
                frequency: Properties.frequencyBit.daily,
                reportClass: DailyReport,
            },
            {
                metric: 'loan_outstanding_diff_spl',
                reportLabel: 'Loan O/S Diff (SPayLater - On Platform)',
                frequency: Properties.frequencyBit.realtime,
                reportClass: RealtimeReport,
            },
            {
                metric: 'loan_outstanding_diff_spl',
                reportLabel: 'Loan O/S Diff (SPayLater - On Platform)',
                frequency: Properties.frequencyBit.daily,
                reportClass: DailyReport,
            },
            {
                metric: 'loan_outstanding_diff_spl-offline',
                reportLabel: 'Loan O/S Diff (SPayLater - Off Platform)',
                frequency: Properties.frequencyBit.realtime,
                reportClass: RealtimeReport,
            },
            {
                metric: 'loan_outstanding_diff_spl-offline',
                reportLabel: 'Loan O/S Diff (SPayLater - Off Platform)',
                frequency: Properties.frequencyBit.daily,
                reportClass: DailyReport,
            },
            {
                metric: 'loan_outstanding_diff_bcl',
                reportLabel: 'Loan O/S Diff (Buyer Cash Loan)',
                frequency: Properties.frequencyBit.realtime,
                reportClass: RealtimeReport,
            },
            {
                metric: 'loan_outstanding_diff_bcl',
                reportLabel: 'Loan O/S Diff (Buyer Cash Loan)',
                frequency: Properties.frequencyBit.daily,
                reportClass: DailyReport,
            },
            {
                metric: 'loan_outstanding_diff_scl',
                reportLabel: 'Loan O/S Diff (Seller Cash Loan)',
                frequency: Properties.frequencyBit.realtime,
                reportClass: RealtimeReport,
            },
            {
                metric: 'loan_outstanding_diff_scl',
                reportLabel: 'Loan O/S Diff (Seller Cash Loan)',
                frequency: Properties.frequencyBit.daily,
                reportClass: DailyReport,
            },
            {
                metric: 'loan_outstanding_diff_fel',
                reportLabel: 'Loan O/S Diff (Fast Escrow)',
                frequency: Properties.frequencyBit.realtime,
                reportClass: RealtimeReport,
            },
            {
                metric: 'loan_outstanding_diff_fel',
                reportLabel: 'Loan O/S Diff (Fast Escrow)',
                frequency: Properties.frequencyBit.daily,
                reportClass: DailyReport,
            },
            {
                metric: 'loan_outstanding_diff_spl-xtra',
                reportLabel: 'Loan O/S Diff (SPL - Xtra)',
                frequency: Properties.frequencyBit.realtime,
                reportClass: RealtimeReport,
            },
            {
                metric: 'loan_outstanding_diff_spl-xtra',
                reportLabel: 'Loan O/S Diff (SPL - Xtra)',
                frequency: Properties.frequencyBit.daily,
                reportClass: DailyReport,
            },
            {
                metric: 'loan_outstanding_diff_tl',
                reportLabel: 'Loan O/S Diff (Term Loan)',
                frequency: Properties.frequencyBit.realtime,
                reportClass: RealtimeReport,
            },
            {
                metric: 'loan_outstanding_diff_tl',
                reportLabel: 'Loan O/S Diff (Term Loan)',
                frequency: Properties.frequencyBit.daily,
                reportClass: DailyReport,
            },
            {
                metric: 'loan_outstanding_diff_spl-total',
                reportLabel: 'Loan O/S Diff (SPayLater - Total)',
                frequency: Properties.frequencyBit.realtime,
                reportClass: RealtimeReport,
            },
            {
                metric: 'loan_outstanding_diff_spl-total',
                reportLabel: 'Loan O/S Diff (SPayLater - Total)',
                frequency: Properties.frequencyBit.daily,
                reportClass: DailyReport,
            },
        ]
        const loanDisbursedConfigDicts = [
            {
                metric: 'loan_disbursed',
                reportLabel: 'Loan Disbursed',
                frequency: Properties.frequencyBit.realtime,
                reportClass: RealtimeReport,
            },
            {
                metric: 'loan_disbursed',
                reportLabel: 'Loan Disbursed',
                frequency: Properties.frequencyBit.daily,
                reportClass: DailyReport,
            },
            {
                metric: 'loan_disbursed_spl',
                reportLabel: 'Loan Disbursed (SPayLater - On Platform)',
                frequency: Properties.frequencyBit.realtime,
                reportClass: RealtimeReport,
            },
            {
                metric: 'loan_disbursed_spl',
                reportLabel: 'Loan Disbursed (SPayLater - On Platform)',
                frequency: Properties.frequencyBit.daily,
                reportClass: DailyReport,
            },
            {
                metric: 'loan_disbursed_spl-offline',
                reportLabel: 'Loan Disbursed (SPayLater - Off Platform)',
                frequency: Properties.frequencyBit.realtime,
                reportClass: RealtimeReport,
            },
            {
                metric: 'loan_disbursed_spl-offline',
                reportLabel: 'Loan Disbursed (SPayLater - Off Platform)',
                frequency: Properties.frequencyBit.daily,
                reportClass: DailyReport,
            },
            {
                metric: 'loan_disbursed_bcl',
                reportLabel: 'Loan Disbursed (Buyer Cash Loan)',
                frequency: Properties.frequencyBit.realtime,
                reportClass: RealtimeReport,
            },
            {
                metric: 'loan_disbursed_bcl',
                reportLabel: 'Loan Disbursed (Buyer Cash Loan)',
                frequency: Properties.frequencyBit.daily,
                reportClass: DailyReport,
            },
            {
                metric: 'loan_disbursed_scl',
                reportLabel: 'Loan Disbursed (Seller Cash Loan)',
                frequency: Properties.frequencyBit.realtime,
                reportClass: RealtimeReport,
            },
            {
                metric: 'loan_disbursed_scl',
                reportLabel: 'Loan Disbursed (Seller Cash Loan)',
                frequency: Properties.frequencyBit.daily,
                reportClass: DailyReport,
            },
            {
                metric: 'loan_disbursed_fel',
                reportLabel: 'Loan Disbursed (Fast Escrow)',
                frequency: Properties.frequencyBit.realtime,
                reportClass: RealtimeReport,
            },
            {
                metric: 'loan_disbursed_fel',
                reportLabel: 'Loan Disbursed (Fast Escrow)',
                frequency: Properties.frequencyBit.daily,
                reportClass: DailyReport,
            },
            {
                metric: 'loan_disbursed_spl-xtra',
                reportLabel: 'Loan Disbursed (SPL - Xtra)',
                frequency: Properties.frequencyBit.realtime,
                reportClass: RealtimeReport,
            },
            {
                metric: 'loan_disbursed_spl-xtra',
                reportLabel: 'Loan Disbursed (SPL - Xtra)',
                frequency: Properties.frequencyBit.daily,
                reportClass: DailyReport,
            },
            {
                metric: 'loan_disbursed_tl',
                reportLabel: 'Loan Disbursed (Term Loan)',
                frequency: Properties.frequencyBit.realtime,
                reportClass: RealtimeReport,
            },
            {
                metric: 'loan_disbursed_tl',
                reportLabel: 'Loan Disbursed (Term Loan)',
                frequency: Properties.frequencyBit.daily,
                reportClass: DailyReport,
            },
            {
                metric: 'loan_disbursed_spl-total',
                reportLabel: 'Loan Disbursed (SPayLater - Total)',
                frequency: Properties.frequencyBit.realtime,
                reportClass: RealtimeReport,
            },
            {
                metric: 'loan_disbursed_spl-total',
                reportLabel: 'Loan Disbursed (SPayLater - Total)',
                frequency: Properties.frequencyBit.daily,
                reportClass: DailyReport,
            },
        ]
        const effectiveBorrowersConfigDicts = [
            {
                metric: 'effective_borrowers',
                reportLabel: 'Effective Borrowers',
                frequency: Properties.frequencyBit.realtime,
                reportClass: RealtimeReport,
            },
            {
                metric: 'effective_borrowers',
                reportLabel: 'Effective Borrowers',
                frequency: Properties.frequencyBit.daily,
                reportClass: DailyReport,
            },
            {
                metric: 'effective_borrowers_spl',
                reportLabel: 'Effective Borrowers (SPayLater - On Platform)',
                frequency: Properties.frequencyBit.realtime,
                reportClass: RealtimeReport,
            },
            {
                metric: 'effective_borrowers_spl',
                reportLabel: 'Effective Borrowers (SPayLater - On Platform)',
                frequency: Properties.frequencyBit.daily,
                reportClass: DailyReport,
            },
            {
                metric: 'effective_borrowers_spl-offline',
                reportLabel: 'Effective Borrowers (SPayLater - Off Platform)',
                frequency: Properties.frequencyBit.realtime,
                reportClass: RealtimeReport,
            },
            {
                metric: 'effective_borrowers_spl-offline',
                reportLabel: 'Effective Borrowers (SPayLater - Off Platform)',
                frequency: Properties.frequencyBit.daily,
                reportClass: DailyReport,
            },
            {
                metric: 'effective_borrowers_bcl',
                reportLabel: 'Effective Borrowers (Buyer Cash Loan)',
                frequency: Properties.frequencyBit.realtime,
                reportClass: RealtimeReport,
            },
            {
                metric: 'effective_borrowers_bcl',
                reportLabel: 'Effective Borrowers (Buyer Cash Loan)',
                frequency: Properties.frequencyBit.daily,
                reportClass: DailyReport,
            },
            {
                metric: 'effective_borrowers_scl',
                reportLabel: 'Effective Borrowers (Seller Cash Loan)',
                frequency: Properties.frequencyBit.realtime,
                reportClass: RealtimeReport,
            },
            {
                metric: 'effective_borrowers_scl',
                reportLabel: 'Effective Borrowers (Seller Cash Loan)',
                frequency: Properties.frequencyBit.daily,
                reportClass: DailyReport,
            },
            {
                metric: 'effective_borrowers_fel',
                reportLabel: 'Effective Borrowers (Fast Escrow)',
                frequency: Properties.frequencyBit.realtime,
                reportClass: RealtimeReport,
            },
            {
                metric: 'effective_borrowers_fel',
                reportLabel: 'Effective Borrowers (Fast Escrow)',
                frequency: Properties.frequencyBit.daily,
                reportClass: DailyReport,
            },
            {
                metric: 'effective_borrowers_spl-xtra',
                reportLabel: 'Effective Borrowers (SPL - Xtra)',
                frequency: Properties.frequencyBit.realtime,
                reportClass: RealtimeReport,
            },
            {
                metric: 'effective_borrowers_spl-xtra',
                reportLabel: 'Effective Borrowers (SPL - Xtra)',
                frequency: Properties.frequencyBit.daily,
                reportClass: DailyReport,
            },
            {
                metric: 'effective_borrowers_tl',
                reportLabel: 'Effective Borrowers (Term Loan)',
                frequency: Properties.frequencyBit.realtime,
                reportClass: RealtimeReport,
            },
            {
                metric: 'effective_borrowers_tl',
                reportLabel: 'Effective Borrowers (Term Loan)',
                frequency: Properties.frequencyBit.daily,
                reportClass: DailyReport,
            },
            {
                metric: 'effective_borrowers_spl-total',
                reportLabel: 'Effective Borrowers (SPayLater - Total)',
                frequency: Properties.frequencyBit.realtime,
                reportClass: RealtimeReport,
            },
            {
                metric: 'effective_borrowers_spl-total',
                reportLabel: 'Effective Borrowers (SPayLater - Total)',
                frequency: Properties.frequencyBit.daily,
                reportClass: DailyReport,
            },
        ]
        const newBorrowersConfigDicts = [
            {
                metric: 'new_borrowers',
                reportLabel: 'New Borrowers',
                frequency: Properties.frequencyBit.realtime,
                reportClass: RealtimeReport,
            },
            {
                metric: 'new_borrowers',
                reportLabel: 'New Borrowers',
                frequency: Properties.frequencyBit.daily,
                reportClass: DailyReport,
            },
            {
                metric: 'new_borrowers_spl',
                reportLabel: 'New Borrowers (SPayLater - On Platform)',
                frequency: Properties.frequencyBit.realtime,
                reportClass: RealtimeReport,
            },
            {
                metric: 'new_borrowers_spl',
                reportLabel: 'New Borrowers (SPayLater - On Platform)',
                frequency: Properties.frequencyBit.daily,
                reportClass: DailyReport,
            },
            {
                metric: 'new_borrowers_spl-offline',
                reportLabel: 'New Borrowers (SPayLater - Off Platform)',
                frequency: Properties.frequencyBit.realtime,
                reportClass: RealtimeReport,
            },
            {
                metric: 'new_borrowers_spl-offline',
                reportLabel: 'New Borrowers (SPayLater - Off Platform)',
                frequency: Properties.frequencyBit.daily,
                reportClass: DailyReport,
            },
            {
                metric: 'new_borrowers_bcl',
                reportLabel: 'New Borrowers (Buyer Cash Loan)',
                frequency: Properties.frequencyBit.realtime,
                reportClass: RealtimeReport,
            },
            {
                metric: 'new_borrowers_bcl',
                reportLabel: 'New Borrowers (Buyer Cash Loan)',
                frequency: Properties.frequencyBit.daily,
                reportClass: DailyReport,
            },
            {
                metric: 'new_borrowers_scl',
                reportLabel: 'New Borrowers (Seller Cash Loan)',
                frequency: Properties.frequencyBit.realtime,
                reportClass: RealtimeReport,
            },
            {
                metric: 'new_borrowers_scl',
                reportLabel: 'New Borrowers (Seller Cash Loan)',
                frequency: Properties.frequencyBit.daily,
                reportClass: DailyReport,
            },
            {
                metric: 'new_borrowers_fel',
                reportLabel: 'New Borrowers (Fast Escrow)',
                frequency: Properties.frequencyBit.realtime,
                reportClass: RealtimeReport,
            },
            {
                metric: 'new_borrowers_fel',
                reportLabel: 'New Borrowers (Fast Escrow)',
                frequency: Properties.frequencyBit.daily,
                reportClass: DailyReport,
            },
            {
                metric: 'new_borrowers_spl-xtra',
                reportLabel: 'New Borrowers (SPL - Xtra)',
                frequency: Properties.frequencyBit.realtime,
                reportClass: RealtimeReport,
            },
            {
                metric: 'new_borrowers_spl-xtra',
                reportLabel: 'New Borrowers (SPL - Xtra)',
                frequency: Properties.frequencyBit.daily,
                reportClass: DailyReport,
            },
            {
                metric: 'new_borrowers_tl',
                reportLabel: 'New Borrowers (Term Loan)',
                frequency: Properties.frequencyBit.realtime,
                reportClass: RealtimeReport,
            },
            {
                metric: 'new_borrowers_tl',
                reportLabel: 'New Borrowers (Term Loan)',
                frequency: Properties.frequencyBit.daily,
                reportClass: DailyReport,
            },
            {
                metric: 'new_borrowers_spl-total',
                reportLabel: 'New Borrowers (SPayLater - Total)',
                frequency: Properties.frequencyBit.realtime,
                reportClass: RealtimeReport,
            },
            {
                metric: 'new_borrowers_spl-total',
                reportLabel: 'New Borrowers (SPayLater - Total)',
                frequency: Properties.frequencyBit.daily,
                reportClass: DailyReport,
            },
        ]
        const outstandingBorrowersConfigDicts = [
            {
                metric: 'outstanding_borrowers',
                reportLabel: 'Outstanding Borrowers',
                frequency: Properties.frequencyBit.daily,
                reportClass: DailyReport,
            },
            {
                metric: 'outstanding_borrowers_spl',
                reportLabel: 'Outstanding Borrowers (SPayLater - On Platform)',
                frequency: Properties.frequencyBit.daily,
                reportClass: DailyReport,
            },
            {
                metric: 'outstanding_borrowers_spl-offline',
                reportLabel: 'Outstanding Borrowers (SPayLater - Off Platform)',
                frequency: Properties.frequencyBit.daily,
                reportClass: DailyReport,
            },
            {
                metric: 'outstanding_borrowers_bcl',
                reportLabel: 'Outstanding Borrowers (Buyer Cash Loan)',
                frequency: Properties.frequencyBit.daily,
                reportClass: DailyReport,
            },
            {
                metric: 'outstanding_borrowers_scl',
                reportLabel: 'Outstanding Borrowers (Seller Cash Loan)',
                frequency: Properties.frequencyBit.daily,
                reportClass: DailyReport,
            },
            {
                metric: 'outstanding_borrowers_fel',
                reportLabel: 'Outstanding Borrowers (Fast Escrow)',
                frequency: Properties.frequencyBit.daily,
                reportClass: DailyReport,
            },
            {
                metric: 'outstanding_borrowers_spl-xtra',
                reportLabel: 'Outstanding Borrowers (SPL - Xtra)',
                frequency: Properties.frequencyBit.daily,
                reportClass: DailyReport,
            },
            {
                metric: 'outstanding_borrowers_tl',
                reportLabel: 'Outstanding Borrowers (Term Loan)',
                frequency: Properties.frequencyBit.daily,
                reportClass: DailyReport,
            },
            {
                metric: 'outstanding_borrowers_spl-total',
                reportLabel: 'Outstanding Borrowers (SPayLater - Total)',
                frequency: Properties.frequencyBit.daily,
                reportClass: DailyReport,
            },
        ]

        const configDicts = [
            ...txnConfigDicts,
            ...tpvConfigDicts,
            ...txnProportionConfigDicts,
            ...gmvProportionConfigDicts,
            ...loanOutstandingConfigDicts,
            ...loanOutstandingDiffConfigDicts,
            ...loanDisbursedConfigDicts,
            ...effectiveBorrowersConfigDicts,
            ...newBorrowersConfigDicts,
            ...outstandingBorrowersConfigDicts,
        ];
        return configDicts.map(configDict => ({
            productGroup: 'credit_api',
            ...configDict
        }))
    }

    getMatchUrl() {
        return '/credit';
    }
}

export {CreditRouter};